jQuery(document).ready(function ($) {
	if (document.querySelector(".COACH__map")) {
		window.initializeCoachesMap = function () {
			console.log("yes");

			let map;
			const bounds = new google.maps.LatLngBounds();
			const mapOptions = {};

			// Display a map on the page
			map = new google.maps.Map(
				document.getElementsByClassName("COACH__map")[0],
				mapOptions
			);

			// Multiple Markers
			const markers = [];
			$("[data-marker]").each((i, element) => {
				const [lat, lng] = $(element).attr("data-marker").split(",");
				markers.push([$(element).attr("data-name"), lat, lng]);
			});

			// Display multiple markers on a map
			let infoWindow = new google.maps.InfoWindow();
			let marker;
			let i;

			// Loop through our array of markers & place each one on the map
			for (i = 0; i < markers.length; i++) {
				var position = new google.maps.LatLng(markers[i][1], markers[i][2]);
				bounds.extend(position);
				marker = new google.maps.Marker({
					position: position,
					map: map,
					title: markers[i][0]
				});

				// // Allow each marker to have an info window
				// google.maps.event.addListener(marker, 'click', (function (marker, i) {
				// 	return function () {
				// 		infoWindow.setContent(infoWindowContent[i][0]);
				// 		infoWindow.open(map, marker);
				// 	}
				// })(marker, i));

				// Automatically center the map fitting all markers on the screen
				map.fitBounds(bounds);
			}
		}

		var script = document.createElement("script");
		script.src =
			"//maps.googleapis.com/maps/api/js?key=AIzaSyD-pfyctn5j_Rfuj-wF8kkc3WivRhPuEgk&sensor=false&callback=initializeCoachesMap";
		document.body.appendChild(script);
	}
});
